/**
 * EL IDIOMA PREFERIDO DEL HOMEOWNER, COMO SE PINTA.
 *
 * Espejo de `backend/src/lib/idiomaPreferido.ts`, que es quien MANDA al guardar: la forma canónica
 * en la base es 'english' | 'spanish', y otro idioma real ("korean") se guarda tal cual. Pero la
 * base todavía tiene grafías viejas ("Spanish", "Español", "ingles"), así que ninguna pantalla
 * puede comparar con `=== 'spanish'`: el chip del cabezal lo hacía y decía "English" para
 * "Spanish" (Robert Warner, 2026-09-19). Todo lo que pinta el idioma pasa por acá.
 */
export const IDIOMAS_PREFERIDOS = ['english', 'spanish'] as const;
export type IdiomaPreferido = (typeof IDIOMAS_PREFERIDOS)[number];

export type IdiomaResuelto = {
  /** 'english' | 'spanish' | 'other' (un idioma real que no es ninguno de los dos) | 'none' (vacío). */
  code: IdiomaPreferido | 'other' | 'none';
  /** Lo que se muestra: "English", "Español" o el texto tal cual ("Korean"). Vacío si no hay. */
  label: string;
};

export function resolverIdioma(v: string | null | undefined): IdiomaResuelto {
  const limpio = (v ?? '').trim().replace(/\s+/g, ' ');
  if (!limpio) return { code: 'none', label: '' };
  if (/span|esp/i.test(limpio)) return { code: 'spanish', label: 'Español' };
  if (/engl|ingl|^en$/i.test(limpio)) return { code: 'english', label: 'English' };
  return { code: 'other', label: limpio.charAt(0).toUpperCase() + limpio.slice(1) };
}

/** El texto del idioma para una fila o un badge; vacío si no hay. */
export const etiquetaIdioma = (v: string | null | undefined): string => resolverIdioma(v).label;
